<template>
  <div v-if="showmenu"
       class="dmb--toolbar">

    <!--side menu für XS screens-->
    <site-menu-drawer v-if="drawer"
                      :items="navBarItems"
                      :current-item="selectedItem"
                      @close="drawer = false"
                      @navigate="doNavigate" />

    <v-app-bar v-resize="onResizeClose"
               :class="smallScreen ? 'light' : 'primary'"
               clipped-left
               dark
               flat>

      <template v-if="smallScreen">

        <!--activator for side menu-->
        <v-app-bar-nav-icon color="primary"
                            class="burger--btn"
                            @click.stop="drawer = true" />

        <!-- inverted logo in navbar for burger menu-->
        <div class="toolbar--logo">
          <img height="32"
               src="@/assets/svg/Logo_DMB-RS.svg"
               alt="DMB Rechtsschutz">
        </div>

      </template>

      <v-toolbar-items v-else>
        <template v-for="(navItem) in navBarItems">
          <div :key="navItem.key"
               :class="navItem.key==='menuUser' ? 'muser' : 'spread'">

            <v-menu :key="navItem.key"
                    :ref="navItem.key"
                    :close-delay="200"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    offset-y
                    content-class="dmb--toolbar--menu">

              <template v-slot:activator="{ on }">
                <div :class="selectedItem === navItem.key ? 'selected' : ''"
                     class="nav--item no--touchstart"
                     v-on="on"
                     @click="navItemClick(navItem.key)">
                  <v-icon v-if="navItem.icon"
                          color="white"
                          class="pr-2">
                    {{ navItem.icon }}
                  </v-icon>
                  <template v-if="navItem.key==='menuUser'">
                    <span class="ueber2 username">{{ user.name }}</span>
                    <span v-if="user.vmnr"
                          class="ueber2">({{ user.vmnr }})</span>
                  </template>
                  <span v-else
                        class="ueber2">{{ navItem.title }}</span>
                </div>
              </template>

              <div class="dmb--overlay"
                   @click="setSelectedItem(); closeMenues();">&nbsp;
              </div>
              <div :id="'dmb-menu-content-' + navItem.key"
                   class="dmb--menu--content menu-content-open"
                   @click="setSelectedItem">

                <folding-menu :title="navItem.title"
                              :welcome="navItem.key === 'menuUser'"
                              :items="navItem.items"
                              @navigate="doNavigate" />
              </div>
            </v-menu>
          </div>
        </template>
      </v-toolbar-items>
    </v-app-bar>
    <confirm ref="confirmreload" />
  </div>
</template>

<script>
import SiteMenuDrawer from "@/components/SiteMenuDrawer";
import FoldingMenu from "@/components/FoldingMenu";
import loggedOutMenuRoot from '@/store/config/loggedOutMenu';
import confirm from '@/components/helper/confirm';

export default {
  name: "SiteMenuToolbar",
  components: {
    SiteMenuDrawer,
    FoldingMenu,
    confirm
  },
  props: {
    smallScreen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      drawer: false,
      selectedItem: "",
      loggedOutMenuRoot
    };
  },
  computed: {
    user: function () {
      return this.$store.getters.user;
    },
    menuRoot() {
      let myRoot = this.$store.getters.menuItems;
      //console.log(this.$browserDetect, this.$browserDetect.meta.name,  this.$browserDetect.meta.ua );
      //let isModernEdge = this.$browserDetect.isChrome && (this.$browserDetect.meta.ua.toString().indexOf('Edg') > 0);
      //if( this.$browserDetect.isChrome || this.$browserDetect.isChromeIOS || this.$browserDetect.isOpera || isModernEdge ) {
      //  myRoot.menuVertriebsunterstuetzung.items.filter(i => i.isChrome).forEach(i => i.path = i.isChrome);
      //}
      return myRoot;
    },
    navBarItems: function () {
      if (!this.$store.getters.isAuthenticated && this.smallScreen) {
        return [
          this.loggedOutMenuRoot.menuStart,
          this.loggedOutMenuRoot.menuLogin,
          this.loggedOutMenuRoot.menuRegister
        ];
      }

      let navItems = this.smallScreen ? [this.loggedOutMenuRoot.menuStart] : [];
      navItems = navItems.concat([
        this.menuRoot.menuAngebotsrechner,
        this.menuRoot.menuProdukte,
        this.menuRoot.menuKundenverwaltung,
        this.menuRoot.menuVertriebsunterstuetzung,
        this.menuRoot.menuAbout,
        this.menuRoot.menuUser
      ]);
      return navItems.filter(ni => ni && (!ni.items || ni.items.length > 0));
    },
    showmenu: function () {
      return this.smallScreen ||
        (this.$route.name !== "LoginPage" && !(this.$route.name === "OnboardingPage" && this.$store.getters.firstLogin) && this.$store.getters.isAuthenticated);
    }
  },
  watch: {
    '$route'(to) {
      this.closeMenues();
      this.drawer = false;
      this.selectedItem = "";
      this.navBarItems.forEach(menu => {
        if (menu.items) {
          menu.items.forEach(item => {
            if (to.fullPath.includes(item.path)) {
              this.selectedItem = menu.key;
            }
          });
        } else {
          if (to.fullPath.includes(menu.path)) {
            this.selectedItem = menu.key;
          }
        }
      });
    }
  },
  mounted: function () {
    this.setSelectedItem();
  },
  methods: {
    setSelectedItem: function () {
      this.selectedItem = "";
      this.navBarItems.forEach(menu => {
        let route = this.$router.currentRoute.fullPath;
        if (menu.items) {
          menu.items.forEach(item => {
            if (route.includes(item.path)) {
              this.selectedItem = menu.key;
            }
          });
        } else {
          if (route === '/' || route.includes('/logout')) {
            this.selectedItem = this.loggedOutMenuRoot.menuStart.key;
            return;
          }
          if (route.includes(menu.path)) {
            this.selectedItem = menu.key;
          }
        }
      });
    },
    onResizeClose() {
      //closes all open menues (iterates over all menus because v-resize expects a callback function without parameters )
      this.closeMenues();
      this.drawer = false;
    },
    doNavigate(path) {
      if (path) {
        if (path.startsWith("http")) {
          window.open(path, "_blank");
        } else {
          const currentPath = this.$router.currentRoute.path;
          this.$router.push(path)
          .catch( err => { if (err.name !== 'NavigationDuplicated') {
              throw err;
            } else if (currentPath === '/gewerbekundenangebot' || currentPath  === '/privatkunden'){
                this.onResizeClose();
                this.$refs.confirmreload
                  .open(
                        'Eingaben zurücksetzen',
                        `Wollen Sie wirklich alle Ihre Eingaben zurücksetzen und ein neues Angebot erstellen?`,
                        { color: 'primary' }
                      )
                  .then(() => {
                    this.$router.go();
                  });
            } else {
              this.onResizeClose();
            }});
          }
      }
    },
    navItemClick(selectedItem) {
      this.setPosition();
      if (this.selectedItem === selectedItem) {
        this.setSelectedItem();
      } else {
        this.selectedItem = selectedItem;
      }
      //fix for mobile devices
      let activeMenu = document.getElementsByClassName("dmb--toolbar--menu menuable__content__active")[0];
      if (!activeMenu) document.documentElement.addEventListener("touchstart", function () {
        this.closeMenues();
      }.bind(this), { once: true });
      //end fix
      setTimeout(() => {
        this.closeMenues(selectedItem);
      }, 100);
    },
    closeMenues(except) {
      this.navBarItems.forEach((menu) => {
        if (this.$refs[menu.key] && this.$refs[menu.key][0] && this.$refs[menu.key][0].isActive && (!except || except !== menu.key)) {
          this.$refs[menu.key][0].isActive = false;
        }
      }, this);
      if (!except) this.setSelectedItem();
    },
    setPosition() {
      let top = document.getElementById("contentInner").classList.contains("scroll-down") ? "48px" : "136px";
      let menus = document.getElementsByClassName("menu-content-open");
      Array.prototype.forEach.call(menus, function (menu) {
        menu.classList.remove('scroll-down-navbar');
        menu.classList.remove('scroll-up-navbar');
        menu.style.top = top;
      });

    }
  }
};
</script>
<style>
.dmb--toolbar {
  width: 100%;
}

.dmb--toolbar .v-app-bar {
  display: flex;
  height: 48px !important;
  justify-content: center;
}

.dmb--toolbar .v-app-bar.light {
  background-color: #ffffff!important;
  border-color: #ffffff!important;
  border-bottom: solid 2px rgba(0, 0, 0, .12)!important;
}

.dmb--toolbar .toolbar--logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 32px;
}

.dmb--toolbar .v-toolbar__content {
  display: flex;
  align-items: center;
  padding: 0 48px;
  height: 48px !important;
  max-width: 1280px !important;
  min-width: 696px !important;
}

.dmb--toolbar .v-toolbar__items {
  height: 48px !important;
  width: 1280px;
  max-width: 1280px;
  margin: 0 !important;
}

.dmb--toolbar .v-toolbar__items .spread {
  display: flex;
  width: 2rem;
  flex-grow: 1;
}

.dmb--toolbar .v-toolbar__items .muser {
  display: flex;
  width: 2rem;
  flex-grow: 1 !important;
}

.dmb--toolbar .v-toolbar__items .muser .username {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 88px);
}

.dmb--toolbar .nav--item {
  height: 100%;
  display: flex !important;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  padding-top: 1px;
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: 2px solid #0085CF;
  cursor: pointer;
}

.dmb--toolbar .nav--item:hover {
  border-color: #002C76;
}

.dmb--toolbar .nav--item.selected {
  background-color: #002C76;
  border-bottom: 2px solid #002C76 !important;
}

.dmb--toolbar .activator {
  height: 100%;
  display: flex;
  align-items: center;
}

@media screen {
  .dmb--toolbar .nav--item {
    min-width: 144px !important;
    max-width: 256px !important;
  }

  .dmb--toolbar .nav--item .ueber2 {
    font-size: 16px !important;
  }
}

.dmb--toolbar .burger--btn {
  position: fixed;
  top: 0;
  left: 0;
  height: 36px;
  width: 36px;
  min-width: 36px;
  margin: 0!important;
}

.dmb--toolbar .burger--btn:before {
  display: none;
}

.dmb--toolbar .burger--btn .v-ripple__container {
  display: none;
}

.dmb--toolbar--menu {
  position: fixed;
  top: 0 !important;
  left: 0 !important;
  right: 0;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  min-height: 100% !important;
  z-index: 18 !important;
  transition: none !important;
}

.dmb--toolbar--menu .dmb--overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  pointer-events: auto;
  touch-action: none;
  background-color: #212121;
  opacity: 0.46;
}

.dmb--menu--content {
  display: flex;
  justify-content: center;
  position: absolute;
  /* top: 136 must be initialized and changed by JS */
  background: #FFFFFF;
  color: rgba(0, 0, 0, .87);
  width: 100%;
  min-height: 300px;
  max-height: 100%;
  scroll-behavior: auto;
  z-index: 19 !important;
  border-bottom: lightgrey solid 1px;
}


/* The animation code */
@keyframes open-menu {
  from {
    transform: translateY(-385px);
  }
  to {
    transform: translateY(0);
  }
}

/* The animation code */
@keyframes close-menu {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-385px);
  }
}

</style>
